<template>
  <div class="cards">
    <IntroCard v-for="card in cards" :key="card.title"
               :text="card.text"
               :title="card.title"
               :imageURL="card.titleGraphic.fields.file.url"></IntroCard>
  </div>
</template>

<script>

import contentfulClient from "@/module/contentful";
import IntroCard from "@/components/IntroCard";

export default {
  name: "IntroCardCreator",
  components: {IntroCard},
  data() {
    return {
      cards: [
      ]
    };
  },
  created: async function() {
    let result = await contentfulClient.getEntries({
      content_type: "infoCard",
    });
    this.cards = result.items.map((item) => item.fields);
  },
};
</script>

<style lang="scss">

</style>
